import { add as addRequest } from 'serviceWorker/db/httpRequests';
import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { ChecklistItemOutDto } from 'shared/dtos/out/template';
import { InspectionTemplateChecklistItemHttpEditRequestModel } from '../httpQueue/inspectionTemplate/types';

export class InspectionTemplateChecklistItemEditor {
  constructor(
    private addRequest: (
      request: InspectionTemplateChecklistItemHttpEditRequestModel
    ) => Promise<unknown>
  ) {}

  async execute(
    templateId: string,
    checklistItemId: string,
    checklistItemOutDto: ChecklistItemOutDto,
    projectId: string,
    uniqueId: string
  ): Promise<void> {
    await this.addRequest({
      createdAt: Date.now(),
      method: 'PUT',
      data: {
        checklistItemOutDto,
        uniqueId,
      },
      url: `/project/${projectId}/inspectionTemplate/${templateId}/checklistItem/${checklistItemId}`,
      entityType: HttpRequestModelType.inspectionTemplate,
      status: HttpRequestStatus.NEW,
    });
  }
}

export const inspectionTemplateChecklistItemEditor =
  new InspectionTemplateChecklistItemEditor(addRequest);
